(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    var showPeopleAlshoPurchased = false;
  var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        $("#shopify-section-product-recommendations").removeClass("hide");
        $("#shopify-section-product-recommendations-slider").removeClass("hide");
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations" && showPeopleAlshoPurchased == true) {
    loadProductRecommendationsIntoSection();
  }
});
  var productRecommendationsSection = document.querySelector(".product-recommendations");
      var vendor = productRecommendationsSection.dataset.vendor;
      const url = 'https://lounges-plus.myshopify.com/api/2023-04/graphql.json';
      const accessToken = '98852fbf1aaf0ac9a46514f7bb25fa36';

             const query = `
                query getProducts($first: Int, $vendor: String!) {
                products(first:$first, query:$vendor) {
                  edges {
                    cursor
                    node {
                      id,
                      title,
                      vendor
                    }
                  }
                }
              }`;
      
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': accessToken,
          },
          body: JSON.stringify({ query, variables: {first: 10, vendor: vendor} }),
        };
      
        fetch(url, options)
          .then(response => response.json())
          .then(data => {
            // Handle the response data
            const products = data.data.products.edges;
              console.log(products.length, 'hahaaaa')
           if(products.length == 1 ){
                showPeopleAlshoPurchased = true
                loadProductRecommendationsIntoSection();
            }
          })
        .catch(error => {
            // Handle the error
            console.log(error);
    });


$("#shopify-section-product-recommendations").addClass("hide");
$("#shopify-section-product-recommendations-slider").addClass("hide");
    // // Select the parent element where new divs will be added
    // const container = document.getElementById('container-a1p');
    // // Create a new MutationObserver instance
    // const observer = new MutationObserver((mutationsList, observer) => {
    //   // Loop through the mutations
    //   for (let mutation of mutationsList) {
    //     // Check if new nodes have been added
    //     if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
    //       // Loop through the added nodes
    //       mutation.addedNodes.forEach(node => {
    //         // Check if the added node is a div element with the desired class name
    //         if (node.nodeName === 'DIV' && node.classList.contains('a1p_grid-box')) {
    //           // Perform the desired action here
    //           console.log('New <div> with class "a1p_grid-box" added:', node);
    //           console.log('Time to hide people also purchased')
    //            $("#shopify-section-product-recommendations").addClass("hide");
    //            $("#shopify-section-product-recommendations-slider").addClass("hide");
    //         }else{
             
    //         }
    //       });
    //     }
    //   }
    // });
    // // Start observing the container for new child nodes
    // observer.observe(container, { childList: true });

  } catch(e) { console.error(e); }
})();
})();
